import { useState } from "react";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useI18n } from "i18n";
import CountdownTimer from "./CountdownTimer";

interface Props {
  startTime: number;
  endTime: number;
  currentTime: number;
  className: string;
  onEnd?: () => void;
}

const EventTime = ({
  currentTime,
  startTime,
  endTime,
  className,
  onEnd,
}: Props) => {
  const { t } = useI18n(["eventLanding"]);
  const [eventStarted, setEventStarted] = useState(currentTime > startTime);

  if (currentTime > endTime) {
    return (
      <Typography
        variant="h4"
        color="error"
        data-testid="event-ended-label"
        aria-label={t("event.ended")}
      >
        {t("event.ended")}
      </Typography>
    );
  }

  if (eventStarted) {
    return (
      <Typography
        variant="h3"
        data-testid="event-started-label"
        aria-label={t("event.started")}
      >
        {`${t("event.started")} 🎉`}
      </Typography>
    );
  }

  return (
    <Container flex column alignItems="flex-start" className={className}>
      <Typography variant="h3">{t("event.start.time")}</Typography>
      <Container alignItems="flex-start" top="sm">
        <CountdownTimer
          startTime={currentTime}
          endTime={startTime}
          onEnd={() => {
            setEventStarted(true);
            onEnd?.();
          }}
        />
      </Container>
    </Container>
  );
};

export default EventTime;
